import { ApplicationSourceEnum } from '../../dto/applicationSource.enum';

export const INTEGRATION_APP_SOURCES = [
  ApplicationSourceEnum.DELIVEROO,
  ApplicationSourceEnum.JUST_EAT,
  ApplicationSourceEnum.UBER,
  ApplicationSourceEnum.WEB_ORDERING,
  ApplicationSourceEnum.WEB_ORDERING_WHITELABEL
];
